export const Required = (): JSX.Element => {
  return <span className="text-red-500">*</span>;
};
